import { KubernetesCluster } from '../KubernetesClusterPicker';

/** Shape of a KaaP tenant as stored on a DaaS project's KaaP cluster entry. */
export type KaapTenant = {
  id?: string;
  name: string;
  clusterId: string | null;
  clusterSubscriptionName?: string;
  clusterName?: string;
  ownerId?: string;
  pimEnabled?: boolean;
  pimGroupId?: string | null;
};

export type NotificationService = 'slack' | 'grafana' | 'github';

export type KaapCluster = {
  tenant: KaapTenant | null;
  namespaces: string[];
};

export type SelfManagedCluster = {
  cluster: KubernetesCluster | null;
  namespaces: string[];
};

export type ClusterConfiguration = {
  kaapClusters: KaapCluster[];
  selfManagedClusters: SelfManagedCluster[];
};

export interface ProjectBasicInfoValue {
  projectName: string;
  description: string;
  projectRef?: string;
}

export interface ProjectNotificationValue {
  notificationChannel: string;
  notificationServices: NotificationService[];
}

export interface ProjectOwnerValue {
  owner: string;
  securityGroups: string[];
  cicdOidcSubjects: string[];
}

export interface DaasProjectInputUiOptions {
  fillEditFormData?: boolean;
}

export interface DaasProjectInputData {
  projectName: string;
  description: string;
  owner: string;
  securityGroups: string[];
  cicdOidcSubjects: string[];
  clusters: ClusterConfiguration;
  notificationChannel: string;
  notificationServices: NotificationService[];
  /** Catalog entity ref for the selected project (e.g. component:default/my-project).
   *  Used in edit mode to unambiguously identify the entity across namespaces. */
  projectRef?: string;
  /** Internal flag: set once after the first auto-prefill from entity data.
   *  Preserved by Backstage formData across navigation to prevent re-prefilling. */
  _initialized?: boolean;
}

export const DEFAULT_CLUSTERS: ClusterConfiguration = {
  kaapClusters: [],
  selfManagedClusters: [],
};

export const DEFAULT_DATA: DaasProjectInputData = {
  projectName: '',
  description: '',
  owner: '',
  securityGroups: [],
  cicdOidcSubjects: [],
  clusters: DEFAULT_CLUSTERS,
  notificationChannel: '',
  notificationServices: [],
};
